import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Simplebar } from '@hivebrite/design-system/Simplebar';

import Grid, { Row, Col } from 'hb-react/shared/components/DesignSystem/Grid';
import FileInfos from 'hb-react/shared/components/FilePreview/Common/Infos';
import FileReactions from 'hb-react/shared/components/FilePreview/Common/Reactions';

import Content from './Content';

const Desktop = ({
  categories,
  file,
  isLoading = false,
  user,
  content,
  hasMessagingButton = false,
  reactions,
  folderUrl,
  showReactions = true,
  postContent,
}) => (
  <GridStyled width="100%" mx={{ _: 0 }}>
    <Row>
      <StyledCol width={({ numCols }) => ({ l: 7 / numCols, xl: 8 / numCols })}>
        <Content
          file={file}
          isLoading={isLoading}
          categories={categories}
          {...content}
        />
      </StyledCol>
      <StyledCol width={({ numCols }) => ({ l: 5 / numCols, xl: 4 / numCols })}>
        <ScrollSimpleBar>
          <WrapperStyled>
            <FileInfos
              file={file}
              user={user}
              hasMessagingButton={hasMessagingButton}
              folderUrl={folderUrl}
              postContent={postContent}
            />
            {showReactions && (
              <FileReactions key={file?.id} file={file} reactions={reactions} />
            )}
          </WrapperStyled>
        </ScrollSimpleBar>
      </StyledCol>
    </Row>
  </GridStyled>
);

Desktop.propTypes = {
  categories: PropTypes.array,
  content: PropTypes.shape({
    onKeyDown: PropTypes.func,
    previousUrl: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    hidePreviousUrl: PropTypes.bool,
    nextUrl: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    hideNextUrl: PropTypes.bool,
  }),
  file: PropTypes.object,
  folderUrl: PropTypes.string,
  hasMessagingButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  reactions: PropTypes.shape({
    type: PropTypes.string,
  }),
  showReactions: PropTypes.bool,
  user: PropTypes.object,
};

export default Desktop;

const GridStyled = styled(Grid)`
  margin-top: 0px;
`;

const ScrollSimpleBar = styled(Simplebar)`
  height: 90vh;
`;

const WrapperStyled = styled(Box).attrs({
  display: 'block',
  py: 5,
  pr: 6,
})``;

const StyledCol = styled(Col)`
  > div {
    padding-top: 0px;
  }

  max-height: 100%;
`;
